<template>
  <div class="main-body">
    <div class="header">养老院机构</div>
    <div class="out">



      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border >

        <el-table-column prop="userDTO.name" label="名称" width="200" fixed></el-table-column>

        <el-table-column prop="userDTO.phone" label="APP账号" width="150"></el-table-column>

        <el-table-column prop="listCommandCenterStaffRelDTO" label="后台账号"   width="150">
          <template slot-scope="scope">
            <span v-for="item in scope.row.listInstitutionStaffRelDTO" v-bind:key="item.institutionStaffRelCode">
              <div>{{item.staffName}}</div>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.type ==1">养老院机构</span>
            <span v-if="scope.row.type ==2">家庭养老床位照料机构</span>
            <span v-if="scope.row.type ==3">社区日间照料机构</span>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="地址" width="250"></el-table-column>
        <el-table-column prop="lon" label="精度" width="180"></el-table-column>
        <el-table-column prop="lat" label="纬度" width="180"></el-table-column>


        <el-table-column prop="createTime" label="创建时间" min-width="180px">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="pageSize"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>


  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "Page",
  components:{

  },

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{
      tableLoading:false,

      loading:false,
      dialogFormVisible:false,

      showModalAdd:false,
      showModalEdit:false,
      showModalEditStaff:false,

      bankCard:'',
      businessCode:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      status:-1,


      pwdDialog: false,
      password: '',
      institutionCode:'',

    }
  },

  created(){
    this.getList();
    this.th = this.$store.state.tableHeight+50;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/GovPage2",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          type:1,
        }
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


    handlePassword(index,row) {
      this.pwdDialog = true;
      this.institutionCode = row.institutionCode;
      this.password = '';
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Institution/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          password: this.password,
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.pwdDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

